(function () {
  // Text exact (sau parțial) din opțiunea dorită
  const PREFERRED_TEXT = '4gb ram / 64gb 4core';

  function selectPreferredVariant() {
    const select = document.getElementById('p-variant-dropdown-1');
    if (!select) return;

    const currentVal = select.value.toLowerCase();
    if (currentVal.includes('4core') && currentVal.includes('4gb')) return;

    const preferred = Array.from(select.options).find(opt =>
      opt.value.toLowerCase().includes(PREFERRED_TEXT)
    );

    if (!preferred) return;

    select.value = preferred.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    select.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function waitAndRun(retries = 15) {
    const select = document.getElementById('p-variant-dropdown-1');
    if (select) {
      setTimeout(selectPreferredVariant, 300);
    } else if (retries > 0) {
      setTimeout(() => waitAndRun(retries - 1), 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => waitAndRun());
  } else {
    waitAndRun();
  }
})();